import { IWithIdentifier } from '@digitaix/types';

export function getRowId(row: IWithIdentifier): string | null {
  return !row ? null : row.id || row._id || row.__id || row.__index.toFixed(0);
}

